import { useOrderSheet } from 'hooks/useOrderSheet';
import { useStartDeliveryModal } from 'hooks/useStartDeliveryModal';
import { openToast } from 'utils/localDispatcher';

interface StartDeliveryButtonProps {
  storeOrderId: string;
  text: string;
  isPrimary: boolean;
  onClick?: () => void;
}

const StartDeliveryButton = ({ storeOrderId, text, isPrimary, onClick }: StartDeliveryButtonProps) => {
  const { openStartDeliveryModal } = useStartDeliveryModal();
  const { invoice } = useOrderSheet(storeOrderId);

  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    onClick?.();

    if(invoice){
      openToast('이미 운송장 번호를 등록한 주문이에요.');
      return;
    }

    openStartDeliveryModal(storeOrderId);
  };

  return (
    <button
      className={`temp-button ${isPrimary ? 'primary' : ''}`}
      onClick={handleClick}
    >
      {text}
    </button>
  );
};

export default StartDeliveryButton;
